import script from "./Pickcode.vue?vue&type=script&setup=true&lang=js"
export * from "./Pickcode.vue?vue&type=script&setup=true&lang=js"

import "./Pickcode.vue?vue&type=style&index=0&id=42b545a0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42b545a0"]])

export default __exports__